import * as React from 'react';
import { SVGProps } from 'react';

const IconThumbUpSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 24a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12Zm24.065-10.8c0-1.21-.981-2.2-2.181-2.2H16.5l1.471-5.327.033-.352c0-.451-.186-.869-.48-1.166L16.367 3 9.5 10.449A2.16 2.16 0 0 0 8.856 12v10.8c0 1.21.982 2.2 2.182 2.2h9.508c.905 0 1.68-.55 2.007-1.342l3.294-7.755c.098-.253.153-.517.153-.803l.065-1.801-.01-.011.01-.088Z" />
  </svg>
);
export default IconThumbUpSizeL;
